import { render } from "./MWForm.vue?vue&type=template&id=2ecc5f74&scoped=true"
import script from "./MWForm.vue?vue&type=script&lang=js"
export * from "./MWForm.vue?vue&type=script&lang=js"

import "./MWForm.vue?vue&type=style&index=0&id=2ecc5f74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecc5f74"]])

export default __exports__